import { render, staticRenderFns } from "./UserTable.vue?vue&type=template&id=16ccf5a7&scoped=true"
import script from "./UserTable.vue?vue&type=script&lang=js"
export * from "./UserTable.vue?vue&type=script&lang=js"
import style0 from "./UserTable.vue?vue&type=style&index=0&id=16ccf5a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ccf5a7",
  null
  
)

export default component.exports